import clsx from 'clsx'
import { useScreenMatch } from 'lib/utilities/screens'
import Button, { ButtonProps } from '../Button/Button'
import Header from '../Header/Header'
import Icon from '../Icon/Icon'

export interface DocumentReminderProps {
  /**
   * Layout of the component to identify which version to show
   */
  layout: 'small' | 'large'
  /**
   * Launches DocumentDashboard where the user goes through the relevant flows to upload their files
   */
  button: ButtonProps
}

export default function DocumentReminder({
  layout,
  button,
}: DocumentReminderProps) {
  const isDesktop = useScreenMatch('lg')

  return (
    <div
      className={clsx(
        'border border-neutral-400 px-4 lg:px-8 rounded-lg',
        layout === 'small' ? 'py-8' : 'py-4 lg:py-[6.75rem] lg:text-center',
      )}
    >
      {layout === 'large' && isDesktop && (
        <Icon icon="travel" className="w-10 h-10 align-middle mb-4" />
      )}
      <Header
        as="h2"
        className={clsx(
          'mb-4',
          layout === 'small' ? 'type-body-1' : 'type-body-1 lg:type-headline-3',
        )}
      >
        {layout === 'small' ? (
          <>Don’t forget to upload your travel documents!</>
        ) : (
          <>Upload your travel documents.</>
        )}
      </Header>
      <p
        className={clsx(
          'mb-4',
          layout === 'small' ? 'type-body-6' : 'type-body-6 lg:type-body-4',
        )}
      >
        International destinations require additional documents before your
        shipment can be fulfilled. Please upload the required documents below.
      </p>
      <Button
        onClick={button.onClick}
        className={clsx(
          'p-4 min-h-[unset] border-0',
          layout === 'small' ? 'type-body-9' : 'type-body-9 lg:type-body-5',
        )}
      >
        Upload documents
      </Button>
    </div>
  )
}
